import classNames from "classnames";

export default function AccordionItem({ parentAccordionId, uniqueId, title, defaultShow = false, children, onClick, className}) {
    return (
        <div className="accordion-item">
            <h2 className="accordion-header">
                <button onClick={() => onClick && onClick(uniqueId)} className={classNames("accordion-button", { '': defaultShow, 'collapsed': !defaultShow }, className)} type="button" data-bs-toggle="collapse" data-bs-target={`#accordion-item-${uniqueId}`} aria-expanded={defaultShow} aria-controls={`accordion-item-${uniqueId}`}>
                    {title}
                </button>
            </h2>
            <div id={`accordion-item-${uniqueId}`} className={classNames("accordion-collapse collapse kg-bg-light", { "show": defaultShow })} data-bs-parent={`#${parentAccordionId}`}>
                <div className="accordion-body">
                    {children}
                </div>
            </div>
        </div>
    );
}